import { useMemo } from 'react';
import { Box, Grid } from '@material-ui/core';

import { EMPTY_LIST } from 'app/app.constants';
import ProjectsTable from 'features/projects/components/ProjectsTable';
import { projectStatusToString } from 'features/projects/projects.mappers';

const ProjectsByStatus = ({
  projects = EMPTY_LIST,
  zoomInAndOutByProjectId,
  isArchiveProject,
  setArchiveProjects,
  isMobileAppView = false,
  toggleProjectsList,
}) => {
  const projectsByStatus = useMemo(
    () =>
      projects
        .groupBy((project) => project.get('status'))
        .sortBy((_, status) => status),
    [projects],
  );

  return projectsByStatus.keySeq().map((status) => {
    const title = projectStatusToString(status);

    return (
      <Grid key={status} container component={Box} marginBottom={4}>
        <ProjectsTable
          title={title}
          projects={projectsByStatus.get(status, EMPTY_LIST)}
          zoomInAndOutByProjectId={zoomInAndOutByProjectId}
          isArchiveProject={isArchiveProject}
          setArchiveProjects={setArchiveProjects}
          isMobileAppView={isMobileAppView}
          toggleProjectsList={toggleProjectsList}
        />
      </Grid>
    );
  });
};

export default ProjectsByStatus;
